module.exports = __webpack_public_path__ + "static/notice-position-dont-a8b4d782a1fdeef4ec11088dc1a10ca7.png";